
import Vue from "vue";
import { Radar } from "vue-chartjs";

export default Vue.extend({
    extends: Radar,
    data() {
        return {
            options: {
                responsive: true,
                maintainAspectRatio: false,
            },
        };
    },
    props: {
        datasets: Array,
        labels: Array,
    },
    computed: {
        chartdata() {
            return {
                labels: this.labels,
                datasets: this.datasets,
            };
        },
    },
    mounted() {
        this.renderChart(this.chartdata, this.options);
    },
});
